module.exports = __webpack_public_path__ + "static/media/din_certco_8C143.ca15df40.png";